import { useState } from 'react';
import { useProperty, useSnowplowTracking, useTranslation } from '@eti/providers';
import { ConnectedSelectBox } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { cx } from '@eti/styles';
import { COUNTRY_CODES, TRAVEL_DOCUMENT_TYPE } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const normalize = selectedOption => {
  var _selectedOption$value;
  return (_selectedOption$value = selectedOption.value) !== null && _selectedOption$value !== void 0 ? _selectedOption$value : undefined;
};
const TravelDocumentType = _ref => {
  let {
    className,
    countryCode,
    form,
    labelRef,
    id,
    options
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const [documentTypeHasChanged, setDocumentTypeHasChanged] = useState(false);
  const format = storedValue => {
    var _options$find;
    return (_options$find = options.find(option => option.value === storedValue)) !== null && _options$find !== void 0 ? _options$find : '';
  };
  const handleOnChange = option => {
    if (p('IbeClient.TravelerDetails.PersistFormData.Enabled')) {
      persistInputData(form, `traveler-${id}-${TRAVEL_DOCUMENT_TYPE}`)(option === null || option === void 0 ? void 0 : option.value);
    }
    if (isSnowplowTrackingEnabled && !documentTypeHasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Select',
        label: 'Travel document type',
        property: option.label,
        value: parseInt(id, 10) + 1
      });
      setDocumentTypeHasChanged(true);
    }
  };
  return /*#__PURE__*/_jsx(ConnectedSelectBox, {
    className: cx(className, MOUSE_FLOW_CLASS_NAMES),
    "data-testid": `document-types-dropdown-${id}`,
    format: format,
    label: t('Passport.DocumentType.Default.Text'),
    labelRef: labelRef,
    name: TRAVEL_DOCUMENT_TYPE,
    normalize: normalize,
    onChange: handleOnChange,
    options: options,
    placeholder: t('TravelerForm.TravelDocumentType.Placeholder'),
    shouldMarkInputAsRequired: countryCode === COUNTRY_CODES.BR,
    validationRuleName: countryCode === COUNTRY_CODES.BR ? TRAVEL_DOCUMENT_TYPE : undefined
  });
};
export default TravelDocumentType;
//# sourceMappingURL=TravelDocumentType.js.map